var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content content-chunk-box"},[_c('contentCorner',[_c('div',{staticClass:"city-box"},[_c('div',{staticClass:"my-map",attrs:{"id":"map"}},[_c('span',{attrs:{"id":"txt_drawships_count"}})])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }